import { Icon } from '@iconify/react';
import React, { useRef, useState } from 'react';
import personFill from '@iconify/icons-eva/person-fill';
import settings2Fill from '@iconify/icons-eva/settings-2-fill';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// Material-UI
import { alpha } from '@mui/material/styles';
import { Button, Box, Divider, MenuItem, Typography, Avatar, IconButton } from '@mui/material';
import { makeStyles } from '@mui/styles';
// Utilities
import { encryptStorage } from '../../CustomStorage';
import { APP_CONSTANTS } from '../../URLConstants';
import { useAuth } from '../../components/customContextProviders/AuthContext';

// Components
import MenuPopover from '../../components/MenuPopover';

// Constants
const MENU_OPTIONS = [
  {
    label: 'Profile',
    icon: personFill,
    linkTo: '/comingsoon'
  },
  {
    label: 'Settings',
    icon: settings2Fill,
    linkTo: '/comingsoon'
  }
];

const useStyles = makeStyles((theme) => ({
  menuItem: {
    fontSize: '14px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px'
    },
    minHeight: '20px',
    borderRadius: '8px',
    marginInline: theme.spacing(1)
  }
}));

export default function AccountPopoverMobile() {
  const classes = useStyles();
  const navigate = useNavigate();
  const { sessionUserData } = useAuth();

  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const signout = async () => {
    try {
      encryptStorage.setItem(APP_CONSTANTS.L_KEY_OF_USER_LOGGEDIN_STATUS, false);
      encryptStorage.removeItem(APP_CONSTANTS.L_KEY_OF_USER_DATA);
      encryptStorage.removeItem(APP_CONSTANTS.L_KEY_OF_USER_ADMIN_SSOTOKEN);
      navigate('/login', { replace: true });
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <>
      <IconButton
        data-testid="account-popover-icon-small-screen"
        onClick={handleOpen}
        aria-label="user-avatar"
        ref={anchorRef}
        sx={{
          display: { xs: 'flex', lg: 'none' },
          padding: 0,
          width: 30,
          height: 30,
          marginLeft: '2px',
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72)
            }
          })
        }}
      >
        <Avatar
          alt="photoURL"
          sx={{
            height: { xs: '24px', md: '30px' },
            width: { xs: '24px', md: '30px' }
          }}
        />
      </IconButton>

      {/* Menu Popover */}
      <MenuPopover
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        sx={{ width: 160 }}
        data-testid="user-menu-small-screen"
      >
        <Box sx={{ my: 1, px: 1 }}>
          <Typography variant="subtitle1" noWrap sx={{ fontSize: '14px' }}>
            {sessionUserData?.user?.name || 'User Name'}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '12px' }} noWrap>
            {sessionUserData?.user?.email || 'user@example.com'}
          </Typography>
        </Box>

        <Divider sx={{ my: 0.5 }} />

        {MENU_OPTIONS.map((option) => (
          <MenuItem
            key={option.label}
            to={option.linkTo}
            component={RouterLink}
            onClick={handleClose}
            sx={{ typography: 'body2', px: 1 }}
            className={classes.menuItem}
          >
            <Box
              component={Icon}
              icon={option.icon}
              sx={{
                mr: 1,
                width: 16,
                height: 16
              }}
            />
            {option.label}
          </MenuItem>
        ))}

        <Box sx={{ p: 1 }}>
          <Button onClick={signout} fullWidth color="inherit" variant="outlined" size="small">
            Logout
          </Button>
        </Box>
      </MenuPopover>
    </>
  );
}
